<form
  [formGroup]="editLifeMapEntryForm"
  class="relative flex h-full w-full flex-col"
  (ngSubmit)="saveLifeMapEntry()"
  #myForm="ngForm"
>
  <div class="flex grow flex-col gap-4 overflow-auto p-4">
    <div class="flex gap-4 justify-between">
      <div class="flex flex-col gap-2">
        <h2 class="">{{ mainTitle }}</h2>
        <h4>{{ 'lifemap.day' | translate }} {{ dayNumberCurrentLifeMapEntryEdited() + 1 }}</h4>
      </div>
      <pl-icon
        [frame]="IconFrame.round"
        [name]="PlIcon.close"
        (click)="discardClicked()"
        class="h-12 w-12 cursor-pointer border-transparent bg-transparent text-pl-gray-700 hover:bg-pl-gray-200"
      />
    </div>
    <div>
      <div class="flex gap-4 justify-between">
        <pl-timepicker
          [formControlName]="FormControlName.timeFrom"
          [isDisabled]="eventIsAddNewEntry()"
          [isFormSubmitted]="true"
          [label]="'lifemap.start_time' | translate"
          [minutesGap]="MINUTES_GAP"
          [format]="timeFormat"
        ></pl-timepicker>
        <pl-timepicker
          #timePickerTo
          [formControlName]="FormControlName.timeTo"
          [isFormSubmitted]="true"
          [label]="(eventIsAddNewEntry() ? 'lifemap.end_time_select' : 'lifemap.end_time') | translate"
          [minutesGap]="MINUTES_GAP"
          [format]="timeFormat"
          [startTimeUsedForDuration]="editLifeMapEntryForm.controls[FormControlName.timeFrom].value"
          [maxDurationInHours]="12"
        ></pl-timepicker>
      </div>
      <p *ngIf="editLifeMapEntryForm.errors" class="text-sm text-pl-error">
        <span *ngIf="!!editLifeMapEntryForm.errors[CustomErrors.durationTooLong]">
          {{
            'lifemap.select_duration_less_than_12_hours'
              | translate: { numberHours: editLifeMapEntryForm.errors[CustomErrors.durationTooLong] }
          }}
        </span>
        <span *ngIf="!!editLifeMapEntryForm.errors[CustomErrors.sameFromAndToTime]">
          {{ 'lifemap.select_different_from_to_time' | translate }}
        </span>
      </p>
      <p *ngIf="displayWarningTimeToOnFollowingDay()" class="text-sm text-pl-gray-450">
        <ng-container
          *ngIf="dayNumberCurrentLifeMapEntryEdited() === lifemapService.NUMBER_DAYS_LIFEMAP - 1; else followingDay"
        >
          <span>{{
            'lifemap.end_time_will_change'
              | translate: { time: timeFormat === TimeFormat.twentyFourHours ? '00:00' : 'midnight' }
          }}</span>
        </ng-container>
        <ng-template #followingDay>
          <span>
            {{ 'lifemap.entry_end_day' | translate: { dayNumber: dayNumberCurrentLifeMapEntryEdited() + 1 + 1 } }}
          </span>
        </ng-template>
      </p>
    </div>

    <div class="flex flex-col gap-2">
      <p>{{ blockLifemap.data.config.entries.chooseCategoryLabel }}</p>
      <div class="flex gap-4">
        <div
          *ngFor="let lifemapType of lifemapTypes()"
          class="flex flex-1 cursor-pointer items-center justify-center gap-2 rounded-lg p-2"
          [ngClass]="{
            'bg-pl-orange-200': editLifeMapEntryForm.controls[FormControlName.type].value === lifemapType.id,
            'border-2 border-pl-gray-500': editLifeMapEntryForm.controls[FormControlName.type].value !== lifemapType.id
          }"
          (click)="onCategorySelected(lifemapType.id)"
        >
          <pl-icon
            [name]="
              editLifeMapEntryForm.controls[FormControlName.type].value === lifemapType.id
                ? PlIcon.tick
                : lifemapType.icon
            "
            class="h-4 w-4 min-w-[1rem]"
          />
          <p class="">{{ lifemapType.label }}</p>
        </div>
      </div>
    </div>

    <ng-container *ngIf="displayQuestionsAndActivityNameDropdown()">
      <pl-dropdown
        class="my-4"
        [formControlName]="FormControlName.activityName"
        [isFormSubmitted]="myForm.submitted"
        [maxlength]="50"
        [options]="allActivities"
        [label]="blockLifemap.data.config.entries.lifeMapEntryLabel"
      />

      <pl-lifemap-questions
        [blockLifemap]="blockLifemap"
        [isFormSubmitted]="myForm.submitted"
        [formControlName]="FormControlName.answers"
      />
    </ng-container>
  </div>
  <div
    *ngIf="displaySnackBar()"
    class="sticky bottom-0 z-10 flex items-center justify-center gap-4 bg-white p-4 lg:pb-0"
  >
    <pl-button [variant]="ButtonVariant.white" (click)="discardClicked()">{{ 'utils.discard' | translate }}</pl-button>
    <pl-button
      [variant]="editLifeMapEntryForm.invalid ? ButtonVariant.lightOrange : ButtonVariant.orange"
      [type]="PlButtonType.submit"
    >
      {{ 'lifemap.save_entry' | translate }}
    </pl-button>
  </div>
</form>
